var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenChecker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.11111 0 0 7.11111 0 16C0 24.8889 7.11111 32 16 32C24.8889 32 32 24.8889 32 16C32 7.11111 24.8889 0 16 0Z",
    fill: "#00C102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5238 21.6374L9.35714 17.4066C8.88095 16.9231 8.88095 16.1978 9.35714 15.7143C9.83333 15.2308 10.5476 15.2308 11.0238 15.7143L14.3571 19.0989L21.9762 11.3626C22.4524 10.8791 23.1667 10.8791 23.6429 11.3626C24.119 11.8462 24.119 12.5714 23.6429 13.0549L15.1905 21.5165C15.1905 21.6374 15.0714 21.6374 14.9524 21.6374C14.8333 21.8791 14.5952 22 14.3571 22C14 22 13.7619 21.7582 13.5238 21.6374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecker);
export default __webpack_public_path__ + "static/media/green_checker.b4c5b504375a47ecde9bf256436ccfe4.svg";
export { ForwardRef as ReactComponent };